import cx from 'classnames';
import React from 'react';
import FlexView from 'react-flexview';
import styles from './flex-layout.module.scss';
function fixProps(props) {
    const fixedProps = { ...props };
    // https://github.com/buildo/react-flexview/issues/83
    if (fixedProps.basis === 0) {
        fixedProps.basis = '0px';
    }
    return fixedProps;
}
export const View = React.forwardRef((props, ref) => {
    const { spacing, className, ...flexProps } = fixProps(props);
    const spacingClassName = spacing ? `spacing-${spacing}` : '';
    return (React.createElement(FlexView, { ref: ref, className: cx(className, spacingClassName), ...flexProps }));
});
export const Horizontal = (props) => {
    const { vAlignContent, minHeight, ...rest } = fixProps(props);
    return (React.createElement(View, { ...rest, className: cx(props.className, styles.horizontal), style: { alignItems: vAlignContent, minHeight } }));
};
export const Vertical = React.forwardRef((props, ref) => {
    const { hAlignContent, minHeight, ...rest } = fixProps(props);
    return (React.createElement(View, { ...rest, className: cx(props.className, styles.vertical), column: true, style: { alignItems: hAlignContent, minHeight }, ref: ref }));
});
//# sourceMappingURL=flex-layout.js.map